var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"error","prominent":"","border":"left","text":""}},[_vm._v(" "+_vm._s(_vm.$t('patientPortal.notifications.expiredHealthCard'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }